import { PublicClientApplication } from '@azure/msal-browser';
import { MICROSOFT_REDIRECT_URI } from './constants';
import { globalConfig } from './globalConfig';
import { fetchAndDecryptConfig } from './services/authConfigService';

let msalInstance: PublicClientApplication | null = null;

export const getMsalInstance = async (): Promise<PublicClientApplication> => {
    if (msalInstance) {
        return msalInstance;
    }
    await fetchAndDecryptConfig()


    // 1. Get values from Global Config
    const clientId = globalConfig.getValue('client_id');
    const tenantId = globalConfig.getValue('tenant_id');

    // Safety check to ensure values are present
    if (!clientId || !tenantId) {
        throw new Error("MSAL Configuration (Client ID or Tenant ID) is missing from Global Config");
    }

    // 2. Create MSAL Config
    const msalConfig = {
        auth: {
            clientId: clientId, // Use the variable we just fetched
            authority: `https://login.microsoftonline.com/${tenantId}`, // Use the variable we just fetched
            redirectUri: MICROSOFT_REDIRECT_URI
        },
        cache: {
            cacheLocation: 'sessionStorage',
            storeAuthStateInCookie: false
        }
    };

    // 3. Initialize and Return
    msalInstance = new PublicClientApplication(msalConfig);
    await msalInstance.initialize();

    return msalInstance;
};

export const getCurrentMsalInstance = (): PublicClientApplication | null => {
    return msalInstance;
};
